const CreateUser = () => {
  return <>Dodaj</>;
};

export default CreateUser;
